export const comments_3787339 = {"data":{"data":[],"links":{}}}